import {
  FETCH_PROJECT_SCHEDULE,
  FETCH_PROJECT_SCHEDULE_START,
  FETCH_PROJECT_SCHEDULE_SUCCESS,
  FETCH_PROJECT_SCHEDULE_ERROR,
  POST_PROJECT_SCHEDULE,
  POST_PROJECT_SCHEDULE_START,
  POST_PROJECT_SCHEDULE_SUCCESS,
  POST_PROJECT_SCHEDULE_ERROR,
  UPDATE_PROJECT_SCHEDULE_CHANGE,
  UPDATE_PROJECT_SCHEDULE_CHANGE_DATE,
  UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT,
  UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED,
  RESET_PROJECT_SCHEDULE_CHANGE
} from './constants'

const fetchProjectSchedule = (projectId) => ({ type: FETCH_PROJECT_SCHEDULE, projectId })
const fetchProjectScheduleStart = () => ({ type: FETCH_PROJECT_SCHEDULE_START })
const fetchProjectScheduleSuccess = () => ({ type: FETCH_PROJECT_SCHEDULE_SUCCESS })
const fetchProjectScheduleError = () => ({ type: FETCH_PROJECT_SCHEDULE_ERROR })

const postProjectSchedule = (projectId, params) => ({ type: POST_PROJECT_SCHEDULE, projectId, params })
const postProjectScheduleStart = () => ({ type: POST_PROJECT_SCHEDULE_START })
const postProjectScheduleSuccess = () => ({ type: POST_PROJECT_SCHEDULE_SUCCESS })
const postProjectScheduleError = () => ({ type: POST_PROJECT_SCHEDULE_ERROR })

const updateProjectScheduleChange = (schedule) => ({ type: UPDATE_PROJECT_SCHEDULE_CHANGE, schedule })
const updateProjectScheduleChangeDate = (param, date) => ({ type: UPDATE_PROJECT_SCHEDULE_CHANGE_DATE, param, date }) 
const updateProjectScheduleChangeDateInput = (param, dateInput) => ({ type: UPDATE_PROJECT_SCHEDULE_CHANGE_DATE_INPUT, param, dateInput })
const updateProjectScheduleChangeToggleEnabled = (param) => ({ type: UPDATE_PROJECT_SCHEDULE_CHANGE_TOGGLE_ENABLED, param }) 

const resetProjectScheduleChange = () => ({ type: RESET_PROJECT_SCHEDULE_CHANGE })

export {
  fetchProjectSchedule,
  fetchProjectScheduleStart,
  fetchProjectScheduleSuccess,
  fetchProjectScheduleError,
  updateProjectScheduleChange,
  updateProjectScheduleChangeDate,
  updateProjectScheduleChangeDateInput,
  updateProjectScheduleChangeToggleEnabled,
  resetProjectScheduleChange,
  postProjectSchedule,
  postProjectScheduleStart,
  postProjectScheduleSuccess,
  postProjectScheduleError
}